import Skeleton, { SkeletonProps } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const SkeletonLoader = (props: SkeletonProps) => {
	return <Skeleton {...props} />
}
